<template>
  <div class="card">
    <b-row>
      <b-col cols="2">App</b-col>
      <b-col cols="1">Version</b-col>
      <b-col cols="1">Release</b-col>
      <b-col cols="3">Release Date</b-col>
      <b-col cols="1">Beta</b-col>
      <b-col cols="3">Beta Date</b-col>
    </b-row>
    <div v-for="app in applicationList" :key="app.id">
      <b-row>
        <b-col cols="2">{{app.product}}</b-col>
        <b-col cols="1">{{app.product_major_version}}</b-col>
        <b-col cols="1">
          <b-link :href="app.release_download">{{app.release}}</b-link>
        </b-col>
        <b-col cols="3">{{app.release_date | moment("dddd, MMMM Do YYYY")}}</b-col>
        <b-col cols="1">
          <b-link :href="app.beta_download">{{app.beta}}</b-link>
        </b-col>
        <b-col cols="3">{{app.beta_date | moment("dddd, MMMM Do YYYY")}}</b-col>
      </b-row>
    </div>
    <!-- <b-table
      striped
      hover
      small
      selectable
      responsive
      primary-key="id"
      head-variant="light"
      select-mode="single"
      :items="applicationList"
      :fields="fields"
      empty-text="No apps to show"
    >
      <template slot="[release_date]" slot-scope="data">{{data.item.release_date |  moment("dddd, MMMM Do YYYY")}}</template>
      <template slot="[beta_date]" slot-scope="data">{{data.item.beta_date |  moment("dddd, MMMM Do YYYY")}}</template>

      <template slot="[release]" slot-scope="data">
        <b-link :href="data.item.release_download">{{data.item.release}}</b-link>
      </template>
      <template slot="[beta]" slot-scope="data">
        <b-link :href="data.item.beta_download">{{data.item.beta}}</b-link>
      </template>
    </b-table>-->
  </div>
</template>
<script>
import axios from 'axios';
import { getEnv, VUE_APP_APP_SNAPSHOT } from '#/utils/env';

export default {
  data() {
    return {
      applicationList: [],
      fields: [
        {
          key: 'product',
          label: 'Product',
          sortable: true,
        },
        {
          key: 'product_major_version',
          label: 'Major Version',
          sortable: true,
        },
        {
          key: 'release',
          label: 'Release Version',
          sortable: true,
        },
        {
          key: 'release_date',
          label: 'Release Date',
          sortable: true,
        },
        {
          key: 'beta',
          label: 'Beta Version',
          sortable: true,
        },
        {
          key: 'beta_date',
          label: 'Beta Date',
          sortable: true,
        },
      ],
    };
  },
  mounted() {
    const appSnapshotUrl = getEnv(VUE_APP_APP_SNAPSHOT);
    const vm = this;
    axios
      .get(appSnapshotUrl)
      .then((response) => {
        // handle success
        console.log('GOT APP PAGE', response.data);
        const data = response.data.map((d) => ({ ...d, id: d.product + d.product_major_version }));
        vm.applicationList = response.data;
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .finally(() => {
        // always executed
      });
  },
};
</script>
<style lang="scss" scoped>
</style>
